import { Col,Row} from "react-bootstrap";
import {
    AdvisoryBoardSection,
    AdvisoryBoardList,
    AdvisoryBoardItem,
} from '../membersStyle';
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { aboutMembersHandler } from "../../../../redux/slices/members/about-members";

const AdvisoryBoard = () => {
    const [advisoryBoardMembersList, setAdvisoryBoardMembersList] = useState([])
    const aboutMembersData = useSelector((state:any) => state?.aboutMembers?.data)
    const dispatch:any = useDispatch();

     useEffect(() => {
          dispatch(aboutMembersHandler())
      },[])
      
    useEffect(() => {
     if(aboutMembersData?.data){
        setAdvisoryBoardMembersList(aboutMembersData.data.advisoryBoardMembers);
     }
    },[aboutMembersData])

    return (
     <AdvisoryBoardSection>
           <Row>
             <Col sm={12}>
                <AdvisoryBoardList>
                    {advisoryBoardMembersList?.map((member:any , index:number) => (
                        <AdvisoryBoardItem key={index+1}>{member.name}</AdvisoryBoardItem>
                    ))}
                </AdvisoryBoardList>
             </Col>
           </Row>
     </AdvisoryBoardSection>
    )
};
export default AdvisoryBoard; 